"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createProperty = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _q = _interopRequireDefault(require("q"));

var createProperty = function createProperty(propertyKey, propertyValue) {
  return _q.default.Promise.resolve((0, _defineProperty2.default)({}, propertyKey, propertyValue));
};

exports.createProperty = createProperty;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/data/upgradeData/transformers/createProperty.js
// module id = 327
// module chunks = 5 6